/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { Container, Grid, styled } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import HeaderBreadcrumbs from "../../../components/HeaderBreadcrumbs";
import Page from '../../../components/Page';
import useLocales from "../../../hooks/useLocales";
import useSettings from "../../../hooks/useSettings";
import Layout from '../../../layouts';
import { setCommentSearch } from "../../../redux/slices/blog/blog.comment";
import { setExam, setExamSituation, setHint } from "../../../redux/slices/gplx.exam.slice";
import { PATH_THIGPLX } from "../../../routes/paths";
import VideoExamSection from "../../../sections/situationExam/VideoExamSection";
import { findExamsAPI, getExamBySlugAPI } from "../../../service/gplx.exam.service";

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(10),
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(15),
    paddingBottom: theme.spacing(15),
  },
}));

SituationExam.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};

export default function SituationExam({ exam }) {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const { reset } = useSelector((state) => state.examS);
  const { translate } = useLocales();

  useEffect(() => {
    dispatch(setExam({ ...exam, status: "Đang thi" }));
    dispatch(setExamSituation({ ...exam.examSituations[0], isAnswered: false }));
    dispatch(setHint(false));
  }, [exam.orderNo, reset]);

  const { search: searchComment } = useSelector((state) => state.blogComment);

  useEffect(() => {
    dispatch(setCommentSearch({ ...searchComment, value: '', page: 0, filterBys: { itemId: exam.id, type: "SITUATIONEXAM" } }));
  }, [exam]);

  const breadcrumbLinks = [
    { name: translate('menu.home'), href: PATH_THIGPLX.home },
    { name: translate('menu.situation'), href: PATH_THIGPLX.situations },
    { name: translate('situationExam.title'), href: "/thi-tinh-huong/thi-thu" },
    { name: `Đề thi số ${exam.orderNo}` }
  ];

  return (
    <Page title={exam.metaTitle} description={exam.metaDescription}>
      <Container maxWidth={themeStretch ? 'xl' : 'lg'}>
        <RootStyle>
          <Grid container my={3} >
            <HeaderBreadcrumbs
              heading={`Đề thi số ${exam.orderNo}`}
              links={breadcrumbLinks}
              subtitle={'Quay lại chọn đề thi mô phỏng khác'}
            />
          </Grid>
          <Grid container my={3} >
            <Grid item xs={12} md={12}>
              <VideoExamSection item={exam} />
            </Grid>
          </Grid>
        </RootStyle>
      </Container>
    </Page >
  );
}

export async function getStaticPaths() {
  const search = { page: 0, size: 50, value: '%%', orders: [{ order: 'asc', property: 'orderNo' }] };
  const resp = await findExamsAPI(search);

  const paths = resp.data.map(s => ({
    params: {
      slug: s.slug
    }
  }));

  return {
    paths,
    fallback: 'blocking',
  };
}

export async function getStaticProps({ params }) {
  const slug = params.slug;

  const { code, data: exam } = await getExamBySlugAPI(slug);

  if (code !== "200") {
    return {
      notFound: true,
    };
  }
  return {
    props: {
      exam
    },
  };
}